import * as types from '../actions';

export default function setIsLoadingAirway(isLoadingAirway) {
  return {
    type: types.VIEWER_SET_IS_LOADING_AIRWAY,
    isLoadingAirway,
  };
}
